import { Geolocation } from '@capacitor/geolocation'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { INames, useAddress } from 'app/lib/hooks/useAddress'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

type Props = {
  onSuccess?: (address: unknown) => void
  names?: INames
}
const prefix = 'component.feedback.result.location_permission'
const KLocationButton: React.FC<Props> = ({ onSuccess, names } = {}) => {
  const [loading, setLoading] = useState(false)
  const { geocode } = useAddress()
  const { tButtonTitle } = ToolBox.useString()
  const {
    modalify: { open }
  } = useFeedbacker()
  const { formatMessage } = useIntl()

  const onClick = async () => {
    setLoading(true)
    try {
      const coordinates = await Geolocation.getCurrentPosition({ enableHighAccuracy: true })
      const address = await geocode(
        {
          lat: coordinates.coords.latitude,
          lng: coordinates.coords.longitude
        },
        names
      )

      onSuccess?.(address)
    } catch (e) {
      open({
        title: formatMessage({ id: `${prefix}.title` }),
        content: formatMessage({ id: `${prefix}.content` }),
        modalType: 'info'
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button type="secondary" loading={loading} onClick={onClick}>
      {tButtonTitle({ recordType: RecordType.checkout, action: 'current_location' })}
    </Button>
  )
}

export default KLocationButton
